module.exports = __webpack_public_path__ + "img/2.c188c91a.jpg";